'use strict';

angular.module('substoreApp.controllers')
    .controller('orderadministrationconfirmationController', OrderadministrationconfirmationController);

function OrderadministrationconfirmationController($scope, dialogData, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts", "#/myproducts");
    $scope.breadcrumb.add("administration");

    $scope.progressBar.setup({ step: 3, administration: true });

    function initDialogData() {
        var data = $scope.data = dialogData;

        var product = productDataCollector.collect(data.product);

        $scope.updateTeaser(
            product.texts.headerTitleProductChangeConfirmation,
            product.texts.headerSubTitleProductChangeConfirmation,
            product.images.headerImageChangeConfirmationResourcePath);

        htmlTruster.trust($scope.data.product);

        $scope.footnotes = product.productDescription.footnotes;

        webtrekk.track('order_administration_confirmation', {
            page_content_id: product.texts.productName.toString() + "-" + product.subscriptionTemplateId,
            shop_product_sku: product.subscriptionTemplateId
        });
    }

    initDialogData();
}
